import React from 'react';
import "./GoogleMap.css"

const GoogleMap = () => {
  return (
    <div className='map'>
      <iframe data-aos="flip-up"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3963.918112489522!2d3.3716943100469647!3d6.532026123037989!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x103b8da92c905bdd%3A0x81f2c91dd1dce462!2s12%20Alade%20St%2C%20Igbobi%2C%20Lagos%20102216%2C%20Lagos%2C%20Nigeria!5e0!3m2!1sen!2sus!4v1727469911992!5m2!1sen!2sus"
        width="700"
        height="400"
        style={{ border: 0 }} 
        allowFullScreen 
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade" 
      ></iframe>
    </div>
  );
};

export default GoogleMap;
